<template lang="html">
  <div class="post-images-blocks">
    <post-images-block v-for="images_block in images_blocks" :blocks-count="blocksCount" :images_block="images_block" :validation="validation" :key="images_block.id" @imagesBlockDeleted="deleteImagesBlock" @imagesBlockUpdated="blockUpdated"></post-images-block>
    <div class="align-center">
      <button v-if="!validation" type="button" class='big-purple-button' @click="addItem">Add section</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['default', 'validation'],
  data() {
    return {
      images_blocks: [],
      lastIndex: 0,
      blocksCount: 0
    };
  },
  methods: {
    addItem() {
      this.lastIndex += 1;
      this.images_blocks.push({
        id: this.lastIndex,
        // text: '',
        videos: []
      });
      this.blocksCount++;
    },
    deleteImagesBlock(removedImagesBlock) {
      this.images_blocks = this.images_blocks.filter((images_block) => {
        if (images_block.id !== removedImagesBlock.id) return true;
      });
      this.blocksCount--;

      this.$emit('updated-images-blocks', this.images_blocks);
    },

    blockUpdated(imageBlock) {
      let foundImageBlockIndex = this.images_blocks.findIndex((_imagesBlock) => {
        return _imagesBlock.id === imageBlock.id;
      });

      if(foundImageBlockIndex !== -1) {
        this.images_blocks[foundImageBlockIndex].text = imageBlock.text;
        this.images_blocks[foundImageBlockIndex].sorted_images_ids = imageBlock.sorted_images_ids;
        this.images_blocks[foundImageBlockIndex].sorted_video_ids = imageBlock.sorted_video_ids;
        this.images_blocks[foundImageBlockIndex].images = imageBlock.images;
      }

      this.$emit('updated-images-blocks', this.images_blocks);
    }
  },
  created() {
    if (!this.default) {
      this.addItem();
    } else {
      this.default.forEach((images_block) => {
        this.images_blocks.push(images_block);
        if (+images_block.id > this.lastIndex) this.lastIndex = +images_block.id;
      });

      this.$emit('updated-images-blocks', this.images_blocks);
      this.blocksCount = this.default.length == 0 ? 1 : this.default.length;
    }
  }
};
</script>